import React from 'react'
import { Avatar, Dropdown, Flex, Layout, Menu, Space, Typography } from 'antd'
import { useLocation, useNavigate } from 'react-router-dom'
import { UserOutlined } from '@ant-design/icons'
import { useAuthContext } from '../../contexts/AuthContext'
import authService from '../../services/authService'
import { useUserContext } from '../../contexts/UserContext'
import AccentureSong from "../../assets/logo2.png"
import { ReactComponent as DownArrow } from '../../assets/arrow-down.svg'
const { Header: AntHeader } = Layout

const consultantHeaderItems = (navigate) => ([
  // {
  //   key: 'dashboard', label: 'Dashboard', onClick: () => navigate('/')
  // },
  {
    key: 'companies', label: 'Companies', onClick: () => navigate('/companies')
  }
])

const adminHeaderItems = (navigate) => ([
  // {
  //   key: 'dashboard', label: 'Dashboard', onClick: () => navigate('/')
  // },
  {
    key: 'consultants', label: 'Consultants', onClick: () => navigate('/consultants')
  }
])

const pathnameToHeaderItemKeyMapping = new Map()
pathnameToHeaderItemKeyMapping.set('/companies', 'companies')
pathnameToHeaderItemKeyMapping.set('/consultants', 'consultants')
pathnameToHeaderItemKeyMapping.set('/', 'dashboard')

const Header = ({ bgColor }) => {

  const navigate = useNavigate()

  const { setIsAuthenticated } = useAuthContext()
  const { role, name } = useUserContext()
  const { pathname } = useLocation()

  const handleLogout = () => {
    authService.logout()
      .then(() => setIsAuthenticated(false))
  }

  return (
    <AntHeader 
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: bgColor,
          
          height: 104,
          padding: '20px 40px 20px 0',
          boxShadow: '0px 22px 22px 0px #EFF3F94D',

        }}
      >
        <Flex align='center' style={{
          padding:'22px 35px 22px 24px',
          boxShadow: '0px 22px 5px 0px #EFF3F94D',
          borderRight: '2.5px solid rgba(139, 164, 194, 0.20)',
          borderBottom: '2.5px solid rgba(139, 164, 194, 0.20)',
          width:'367px',
          height:'104px',
          justifyContent:'center'
        }}>
          <img style={{height:'75px', cursor: 'pointer' }} src={AccentureSong} onClick={() => navigate('/')} alt="" />
        </Flex>
        
        {/* <Menu 
          style={{
            flex: 1,
            minWidth: 0,
          }} 
          defaultSelectedKeys={[pathnameToHeaderItemKeyMapping.get(pathname)]}
          items={role === 'admin' ? adminHeaderItems(navigate) : consultantHeaderItems(navigate)} theme='light' mode='horizontal' /> */}
        <Dropdown
          trigger={['click']}
          menu={{
            items: [
              // {key: '1', label: 'Profile'},
              // {key: '3', label: 'Settings'},
              // {type: 'divider'},
              {key: 'logout', label: 'Logout', onClick: handleLogout},
            ],
          }}
          placement="bottomRight"
          arrow
        >
          <Flex gap={13} style={{ cursor: 'pointer' }}>
            <Avatar size={55}><UserOutlined/></Avatar>
            <Flex vertical={true} justify="center">
              <Flex justify="space-between">
                <Typography.Text
                  style={{
                    // fontFamily: 'Zemestro-Bold',
                    fontSize: 16,
                    fontWeight: 700,
                    letterSpacing: '0.5px',
                    lineHeight: '16px',
                    marginRight: '8px'
                  }}
                >{name}</Typography.Text>
                <DownArrow height={15} width={15}/>
              </Flex>
              <Typography.Text
                style={{
                  // fontFamily: 'Zemestro-Std',
                  fontSize: 14,
                  fontWeight: 300,
                  letterSpacing: '0.25px',
                  lineHeight: '20px',
                  color: '#808286',
                }}
              >{role === 'admin' ? 'Admin' : 'Consultant'}</Typography.Text>
            </Flex>
          </Flex>
        </Dropdown>
      </AntHeader>
  )
}

export default Header